namespace Areas {
    "use strict";

    export enum DialogResult { Ok, Cancel }      

    export abstract class BaseDialog {
        readonly cancelButtonId: string = "CancelDialog";
        readonly okButtonId: string = "OkDialog";
        
        readonly url: string;
        readonly popupId: string;

        protected rootElementId: string;
        protected dialogName: string;
        protected popup: DevExpress.ui.dxPopup;
        protected parameters: any;

        protected closeHandler: (dialogResult: DialogResult, data: any) => void;
        protected extraInitialization: () => void;
        
        constructor(dialogName: string, closeHandler: (dialogResult: DialogResult, data: any) => void, 
            parameters: any = null, extraInitialization: ()=> void = null, rootElementId: string = "dialog") {
            this.rootElementId = rootElementId;
            this.dialogName = dialogName;
            this.closeHandler = closeHandler;
            this.extraInitialization = extraInitialization;
            this.url = `/Dialog/${this.dialogName}/Index`;
            this.popupId = `#${this.dialogName}Popup`;
            this.parameters = parameters;

            this.initialize();
        }

        private initialize() {
            $(`#${this.rootElementId}`).load(this.url, (response, status) => {
    
                $(`#${this.rootElementId}`).html(response);
    
                this.popup = $(this.popupId).dxPopup("instance");

                this.popup.show();

                var cancelButton = $(`#${this.dialogName}${this.cancelButtonId}`).dxButton("instance");
                if (cancelButton) {
                    cancelButton.on({click: this.cancel});
                }

                var okButton = $(`#${this.dialogName}${this.okButtonId}`).dxButton("instance");
                if (okButton) {
                    okButton.on({click: this.ok});
                }
                
                if (this.extraInitialization) {
                    this.extraInitialization();
                }
            });        
        }

        protected cancel = (e: any) => {
            this.close(DialogResult.Cancel, null);
        }   

        protected abstract ok = (e: any): void => {};

        public close(dialogResult: DialogResult, data: any) {
            this.popup.hide();
            this.closeHandler(dialogResult, data);
            this.clear();            
        }

        private clear() {
            $(`#${this.rootElementId}`).empty();
        }        
    }    
}